// The one QueryClient. Options arrive with the data layer (L4-04): which errors retry depends on the problem
// mapping (401 re-authentication, 409 and 412 the conflict view), so nothing is guessed here.

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient();
